import {Injectable} from '@angular/core';
import {Keys} from '@shared/keys';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  public filter<T>(items: T[],
                   keys: Keys<T>,
                   searchTerms: string): T[] {

    if (!items || !keys || !searchTerms || items.length === 0 || keys.length === 0) {
      return items;
    }

    const terms = searchTerms.split(' ')
      .filter(x => x.length > 0)
      .map(x => x.toLowerCase());

    if (terms.length === 0) {
      return items;
    }

    return items.filter(item => {
      const combinedValues = keys
        .map(key => item[key])
        .filter((value): value is Extract<T[keyof T], string | number | boolean> => value !== undefined && value !== null && typeof value !== 'object')
        .map(String)
        .join(' ')
        .toLowerCase();

      return terms.every(term => combinedValues.includes(term));
    });
  }
}
